(() => {
  'use strict';
  const VERSION = 'zaine-device-quiz-20260921-ledmax-v3';
  if (!/\/pages\/take-the-quiz\/?$/i.test(location.pathname)) return;

  const PRODUCTS = {
    faceMask: {
      key: 'faceMask',
      name: 'Nuovaluce LED Light Therapy Face Mask',
      handle: 'nuovaluce-led-light-therapy-face-masks',
      short: 'Best for a simple, hands-free full-face routine focused on glow, fine lines, and overall skin radiance.',
      bestFor: ['Full-face glow', 'Fine lines', 'Easy daily routine']
    },
    ledMax: {
      key: 'ledMax',
      name: 'Nuovaluce LED Max Light Therapy Face Mask',
      handle: 'nuovaluce-led-max-light-therapy-face-mask',
      short: 'Best for our most advanced full-face routine — 360 LEDs, five wavelengths, five targeted modes, and complete chin coverage in a wireless design.',
      bestFor: ['Most advanced', 'Full-face + chin', 'Fine lines & firmness']
    },
    max: {
      key: 'max',
      name: 'Nuovaluce Anti Aging Max Device',
      handle: 'nuovaluce-anti-aging-device-max',
      short: 'Best for a more targeted, intensive anti-aging routine around firmness, wrinkles, jawline, and deeper facial concerns.',
      bestFor: ['Firmness', 'Wrinkles', 'Targeted treatment']
    },
    eyeGlow: {
      key: 'eyeGlow',
      name: 'Nuovaluce EyeGlow Red Light Therapy Eye Mask',
      handle: 'nuovaluce-eyeglow-red-light-therapy-eye-mask',
      short: 'Best for the eye area — puffiness, dark circles, tired-looking eyes, and a quick focused routine.',
      bestFor: ['Dark circles', 'Puffiness', 'Eye-area care']
    },
    laserBag: {
      key: 'laserBag',
      name: 'Nuovaluce Red Light Therapy Laser Bag',
      handle: 'nuovaluce-red-light-therapy-laser-blanket',
      short: 'Best for body recovery support across larger areas like back, shoulders, legs, or post-workout soreness.',
      bestFor: ['Body recovery', 'Back & shoulders', 'Larger areas']
    },
    heatPad: {
      key: 'heatPad',
      name: 'Nuovaluce Red Infrared Light Heating Pad',
      handle: 'nuovaluce-red-infrared-light-heating-pad',
      short: 'Best for localized comfort when you want red/infrared light with soothing heat on tight or sore areas.',
      bestFor: ['Localized comfort', 'Heat support', 'Targeted soreness']
    }
  };

  const QUESTIONS = [
    {
      id: 'area',
      eyebrow: 'Step 1 of 4',
      title: 'What area do you want to treat most?',
      subtitle: 'Start with the area you care about most — we’ll match the right Nuovaluce device.',
      options: [
        { label: 'Full face', scores: { ledMax: 6, max: 2, faceMask: 1 } },
        { label: 'Eyes', scores: { eyeGlow: 6 } },
        { label: 'Neck, jawline, or targeted facial areas', scores: { max: 5, ledMax: 4, faceMask: 1 } },
        { label: 'Body, back, or shoulders', scores: { laserBag: 6, heatPad: 2 } },
        { label: 'A tight or sore localized area', scores: { heatPad: 6, laserBag: 2 } }
      ]
    },
    {
      id: 'goal',
      eyebrow: 'Step 2 of 4',
      title: 'What do you want your device to help with?',
      subtitle: 'Select all that apply — then tap Next.',
      multi: true,
      options: [
        { label: 'Smooth fine lines & wrinkles', scores: { ledMax: 5, max: 4, faceMask: 2 } },
        { label: 'Improve firmness and definition', scores: { max: 5, ledMax: 4, faceMask: 1 } },
        { label: 'Boost glow and overall radiance', scores: { ledMax: 6, faceMask: 2, max: 1 } },
        { label: 'Target puffiness or dark circles', scores: { eyeGlow: 6 } },
        { label: 'Support recovery, comfort, or tension relief', scores: { laserBag: 4, heatPad: 4 } }
      ]
    },
    {
      id: 'routine',
      eyebrow: 'Step 3 of 4',
      title: 'What kind of routine do you prefer?',
      subtitle: 'This helps us separate easy daily devices from more targeted tools.',
      options: [
        { label: 'Hands-free and easy', scores: { ledMax: 5, faceMask: 2, eyeGlow: 2, laserBag: 1 } },
        { label: 'Targeted and more intensive', scores: { max: 5, ledMax: 2, heatPad: 2 } },
        { label: 'A short daily beauty routine', scores: { ledMax: 4, faceMask: 2, eyeGlow: 3 } },
        { label: 'A body recovery routine', scores: { laserBag: 5, heatPad: 3 } }
      ]
    },
    {
      id: 'experience',
      eyebrow: 'Step 4 of 4',
      title: 'How experienced are you with light therapy?',
      subtitle: 'No wrong answer — this just tunes the recommendation.',
      options: [
        { label: 'First time — I want the easiest option', scores: { ledMax: 5, faceMask: 2, eyeGlow: 2 } },
        { label: 'I’ve used beauty devices before', scores: { ledMax: 4, max: 3, faceMask: 1 } },
        { label: 'I want the strongest at-home option', scores: { ledMax: 6, max: 5, laserBag: 1 } },
        { label: 'I’m shopping for body wellness/recovery', scores: { laserBag: 4, heatPad: 4 } }
      ]
    }
  ];

  const state = { step: 0, answers: {}, multiDraft: {}, productData: {}, email: '', emailStatus: '' };
  const productUrl = handle => `/products/${handle}`;

  function getBrandLogo() {
    const headerLogo = document.querySelector('.header__heading-logo');
    return headerLogo?.currentSrc || headerLogo?.src || 'https://nuovalucebeauty.com/cdn/shop/files/Gemini_Generated_Image_8o4e0o8o4e0o8o4e_png.jpg?v=1775257651&width=240';
  }

  function injectStyles() {
    if (document.getElementById('zaine-device-quiz-style')) return;
    const style = document.createElement('style');
    style.id = 'zaine-device-quiz-style';
    style.textContent = `
      .zaine-device-quiz, .zaine-device-quiz * { box-sizing: border-box; }
      .zaine-device-quiz { --zaine-brand: #42C6B7; --zaine-brand-rgb: 66,198,183; --zaine-brand-dark: #218E84; --zaine-brand-soft: rgba(66,198,183,.10); }
      .zaine-device-quiz { max-width: 1120px; margin: 0 auto 56px; color: rgb(var(--color-foreground, 18,18,18)); font-family: var(--font-body-family, inherit); }
      .zaine-device-quiz__hero { text-align:center; padding: 18px 16px 22px; }
      .zaine-device-quiz__brand { display:none !important; }
      body.zaine-device-quiz-active main .main-page-title,
      body.zaine-device-quiz-active main h1.main-page-title,
      body.zaine-device-quiz-active main .page-title,
      body.zaine-device-quiz-active main h1:first-child { display:none !important; }
      .zaine-device-quiz__logo { display:block; max-width:210px; width:min(210px, 58vw); height:auto; object-fit:contain; }
      .zaine-device-quiz__headline { font-size: clamp(30px, 5vw, 54px); line-height:1.02; margin:0 auto 12px; font-weight:800; max-width:850px; color:rgb(var(--color-foreground, 18,18,18)); }
      .zaine-device-quiz__sub { max-width:650px; margin:0 auto; color:rgba(var(--color-foreground, 18,18,18), .72); font-size:17px; line-height:1.55; }
      .zaine-device-quiz__card { position:relative; overflow:hidden; background: radial-gradient(circle at 12% 16%, rgba(255,255,255,.92) 0 0, rgba(255,255,255,.92) 92px, transparent 93px), linear-gradient(135deg, rgba(66,198,183,.30) 0%, rgba(66,198,183,.15) 42%, rgba(255,255,255,.96) 100%); border:1px solid rgba(var(--zaine-brand-rgb), .36); box-shadow:0 24px 60px rgba(var(--zaine-brand-rgb), .22); border-radius:34px; padding: clamp(24px, 4vw, 48px); }
      .zaine-device-quiz__card::before { content:""; position:absolute; right:-90px; top:-110px; width:280px; height:280px; border-radius:50%; background:rgba(var(--zaine-brand-rgb), .20); pointer-events:none; }
      .zaine-device-quiz__card::after { content:""; position:absolute; left:-80px; bottom:-120px; width:260px; height:260px; border-radius:50%; background:rgba(var(--zaine-brand-rgb), .14); pointer-events:none; }
      .zaine-device-quiz__card > * { position:relative; z-index:1; }
      .zaine-device-quiz__progress { height:9px; background:rgba(255,255,255,.70); border-radius:99px; overflow:hidden; margin:0 0 30px; box-shadow: inset 0 0 0 1px rgba(var(--zaine-brand-rgb), .18); }
      .zaine-device-quiz__bar { height:100%; width:0%; background:linear-gradient(90deg, var(--zaine-brand), var(--zaine-brand-dark)); transition:width .25s ease; }
      .zaine-device-quiz__eyebrow { color:var(--zaine-brand-dark); text-transform:uppercase; letter-spacing:.14em; font-size:12px; font-weight:800; margin-bottom:8px; }
      .zaine-device-quiz__title { font-size: clamp(25px, 3vw, 38px); line-height:1.12; margin:0 0 8px; color:rgb(var(--color-foreground, 18,18,18)); font-weight:800; }
      .zaine-device-quiz__subtitle { color:rgba(var(--color-foreground, 18,18,18), .72); margin:0 0 24px; font-size:16px; line-height:1.5; }
      .zaine-device-quiz__options { display:grid; grid-template-columns:repeat(auto-fit, minmax(145px, 1fr)); gap:16px; margin: 4px 0 0; padding:0; list-style:none; }
      .zaine-device-quiz__option { width:100%; height:196px; min-height:196px; border:1px solid rgba(var(--zaine-brand-rgb), .32); background:rgba(255,255,255,.94); color:rgb(var(--color-foreground, 18,18,18)); text-align:center; border-radius:26px; padding:20px 14px 18px; font-size:16px; line-height:1.25; cursor:pointer; display:flex; flex-direction:column; align-items:center; justify-content:center; gap:14px; font-weight:800; box-shadow:0 12px 30px rgba(var(--zaine-brand-rgb), .11); transition: transform .16s ease, border-color .16s ease, box-shadow .16s ease, background-color .16s ease; }
      .zaine-device-quiz__icon { width:82px; height:82px; border-radius:50%; display:flex; align-items:center; justify-content:center; background:rgba(var(--zaine-brand-rgb), .12); border:1px solid rgba(var(--zaine-brand-rgb), .32); }
      .zaine-device-quiz__icon svg { width:48px; height:48px; fill:none; stroke:var(--zaine-brand-dark); stroke-width:3.2; stroke-linecap:round; stroke-linejoin:round; flex:0 0 48px; max-width:48px; max-height:48px; display:block; }
      .zaine-device-quiz__icon svg.zaine-device-quiz__svg-mark { width:42px; height:42px; flex-basis:42px; max-width:42px; max-height:42px; }
      .zaine-device-quiz__option-text { display:block; max-width:135px; }
      .zaine-device-quiz__option:hover, .zaine-device-quiz__option:focus { outline:none; transform:translateY(-3px); border-color:var(--zaine-brand); box-shadow:0 18px 35px rgba(var(--zaine-brand-rgb), .26); background:#fff; }
      .zaine-device-quiz__option.is-selected { border-color:var(--zaine-brand-dark); background:rgba(var(--zaine-brand-rgb), .18); box-shadow:0 18px 35px rgba(var(--zaine-brand-rgb), .24); }
      .zaine-device-quiz__option.is-selected .zaine-device-quiz__icon { background:var(--zaine-brand); border-color:var(--zaine-brand-dark); }
      .zaine-device-quiz__option.is-selected .zaine-device-quiz__icon svg { stroke:#082f2c; }
      .zaine-device-quiz__next { border:0; min-height:50px; padding:0 28px; border-radius:999px; background:var(--zaine-brand); color:#082f2c; font-weight:900; cursor:pointer; box-shadow:0 12px 24px rgba(var(--zaine-brand-rgb), .20); }
      .zaine-device-quiz__next:disabled { opacity:.45; cursor:not-allowed; box-shadow:none; }
      .zaine-device-quiz__email-card { max-width:640px; margin:0 auto; text-align:center; }
      .zaine-device-quiz__email-form { display:grid; gap:12px; margin-top:22px; }
      .zaine-device-quiz__email-input { width:100%; min-height:56px; border-radius:999px; border:1px solid rgba(var(--zaine-brand-rgb), .38); padding:0 22px; font-size:16px; background:#fff; color:rgb(var(--color-foreground,18,18,18)); }
      .zaine-device-quiz__email-input:focus { outline:none; border-color:var(--zaine-brand-dark); box-shadow:0 0 0 4px rgba(var(--zaine-brand-rgb), .16); }
      .zaine-device-quiz__fine-print { font-size:12px; color:rgba(var(--color-foreground,18,18,18), .62); line-height:1.45; margin:4px auto 0; max-width:520px; }
      .zaine-device-quiz__skip { border:0; background:transparent; color:var(--zaine-brand-dark); text-decoration:underline; cursor:pointer; font-weight:800; padding:8px; }
      .zaine-device-quiz__loading { max-width:680px; margin:0 auto; text-align:center; padding:18px 0 4px; }
      .zaine-device-quiz__orb { width:132px; height:132px; margin:0 auto 24px; border-radius:50%; position:relative; background:radial-gradient(circle at 32% 28%, #ffffff 0 9%, rgba(255,255,255,.94) 10% 16%, rgba(var(--zaine-brand-rgb),.92) 17% 42%, rgba(33,142,132,.86) 43% 68%, rgba(8,47,44,.92) 69% 100%); box-shadow:0 0 0 12px rgba(var(--zaine-brand-rgb),.10), 0 0 42px rgba(var(--zaine-brand-rgb),.52), inset -18px -24px 36px rgba(8,47,44,.24); animation:zaine-orb-pulse 1.65s ease-in-out infinite; }
      .zaine-device-quiz__orb::before { content:""; position:absolute; inset:-9px; border-radius:50%; border:2px solid transparent; border-top-color:var(--zaine-brand); border-right-color:rgba(255,255,255,.88); animation:zaine-orb-spin 1.05s linear infinite; }
      .zaine-device-quiz__orb::after { content:""; position:absolute; inset:18px; border-radius:50%; border:1px solid rgba(255,255,255,.52); border-left-color:transparent; animation:zaine-orb-spin 1.85s linear infinite reverse; }
      .zaine-device-quiz__loading-steps { display:grid; gap:8px; margin:18px auto 0; max-width:460px; color:rgba(var(--color-foreground,18,18,18),.70); font-size:14px; line-height:1.4; }
      .zaine-device-quiz__loading-steps span { display:block; padding:8px 12px; border-radius:999px; background:rgba(255,255,255,.62); border:1px solid rgba(var(--zaine-brand-rgb),.18); }
      @keyframes zaine-orb-spin { to { transform:rotate(360deg); } }
      @keyframes zaine-orb-pulse { 0%,100% { transform:scale(.98); filter:saturate(1); } 50% { transform:scale(1.04); filter:saturate(1.22); } }
      .zaine-device-quiz__nav { display:flex; justify-content:space-between; gap:12px; margin-top:26px; align-items:center; }
      .zaine-device-quiz__back, .zaine-device-quiz__reset { border:0; background:transparent; color:var(--zaine-brand-dark); text-decoration:underline; cursor:pointer; font-weight:700; padding:10px 0; }
      .zaine-device-quiz__result-grid { display:grid; grid-template-columns: minmax(0, .9fr) minmax(0, 1.1fr); gap:28px; align-items:center; }
      .zaine-device-quiz__image-wrap { background:rgb(var(--color-background, 255,255,255)); border:1px solid rgba(var(--zaine-brand-rgb), .26); border-radius:24px; padding:20px; min-height:260px; display:flex; align-items:center; justify-content:center; }
      .zaine-device-quiz__image { max-width:100%; max-height:360px; object-fit:contain; display:block; }
      .zaine-device-quiz__match { color:var(--zaine-brand-dark); text-transform:uppercase; letter-spacing:.15em; font-size:12px; font-weight:900; margin-bottom:8px; }
      .zaine-device-quiz__product-title { font-size: clamp(26px, 4vw, 44px); line-height:1.05; margin:0 0 12px; color:rgb(var(--color-foreground, 18,18,18)); font-weight:900; }
      .zaine-device-quiz__copy { color:rgba(var(--color-foreground, 18,18,18), .72); font-size:17px; line-height:1.55; margin:0 0 18px; }
      .zaine-device-quiz__chips { display:flex; flex-wrap:wrap; gap:8px; margin:0 0 24px; padding:0; list-style:none; }
      .zaine-device-quiz__chip { background:rgba(var(--zaine-brand-rgb), .13); color:#155f59; border-radius:999px; padding:8px 12px; font-size:13px; font-weight:700; }
      .zaine-device-quiz__cta-row { display:flex; flex-wrap:wrap; gap:12px; align-items:center; }
      .zaine-device-quiz__cta { display:inline-flex; align-items:center; justify-content:center; min-height:50px; padding:0 24px; border-radius:999px; background:var(--zaine-brand); color:#082f2c !important; text-decoration:none; font-weight:900; letter-spacing:.02em; }
      .zaine-device-quiz__secondary { color:rgba(var(--color-foreground, 18,18,18), .75); font-weight:800; }
      .zaine-device-quiz__also { margin-top:24px; padding-top:20px; border-top:1px solid rgba(var(--zaine-brand-rgb), .26); color:rgba(var(--color-foreground, 18,18,18), .72); }
      .zaine-device-quiz__also a { color:var(--zaine-brand-dark); font-weight:800; }
      body.zaine-device-quiz-active .octane-ai-quiz-rendered,
      body.zaine-device-quiz-active [data-quiz-id],
      body.zaine-device-quiz-active .rte > div:has([data-quiz-id]),
      body.zaine-device-quiz-active .nl-quiz { display:none !important; }
      @media (max-width: 760px) {
        .zaine-device-quiz { margin-bottom:34px; }
        .zaine-device-quiz__hero { padding-top:8px; }
        .zaine-device-quiz__card { border-radius:24px; padding:20px; }
        .zaine-device-quiz__options { grid-template-columns:1fr 1fr; gap:12px; }
        .zaine-device-quiz__option { height:172px; min-height:172px; border-radius:20px; font-size:14px; padding:16px 10px; }
        .zaine-device-quiz__icon { width:66px; height:66px; }
        .zaine-device-quiz__icon svg { width:38px; height:38px; flex-basis:38px; max-width:38px; max-height:38px; }
        .zaine-device-quiz__icon svg.zaine-device-quiz__svg-mark { width:34px; height:34px; flex-basis:34px; max-width:34px; max-height:34px; }
        .zaine-device-quiz__result-grid { grid-template-columns:1fr; gap:18px; }
        .zaine-device-quiz__image-wrap { min-height:190px; }
        .zaine-device-quiz__cta-row { align-items:stretch; flex-direction:column; }
        .zaine-device-quiz__cta, .zaine-device-quiz__next { width:100%; }
        .zaine-device-quiz__email-card { text-align:left; }
      }
    `;
    document.head.appendChild(style);
  }

  async function fetchProducts() {
    try {
      const res = await fetch('/products.json?limit=250', { credentials: 'same-origin' });
      const data = await res.json();
      (data.products || []).forEach(product => {
        const key = Object.keys(PRODUCTS).find(k => PRODUCTS[k].handle === product.handle);
        if (!key) return;
        state.productData[key] = {
          title: product.title,
          url: productUrl(product.handle),
          image: product.images?.[0]?.src || '',
          price: product.variants?.[0]?.price || '',
          available: (product.variants || []).some(v => v && v.available === true)
        };
      });
    } catch (err) {
      console.warn('[Nuovaluce device quiz] product fetch failed', err);
    }
  }

  function scores() {
    const out = Object.fromEntries(Object.keys(PRODUCTS).map(k => [k, 0]));
    Object.values(state.answers).forEach(answer => {
      const answers = Array.isArray(answer) ? answer : [answer];
      answers.forEach(item => {
        Object.entries(item?.scores || {}).forEach(([key, value]) => { out[key] = (out[key] || 0) + value; });
      });
    });
    return Object.entries(out).sort((a, b) => b[1] - a[1]);
  }

  // Availability-aware ranking: only recommend devices that exist in the
  // catalog AND have at least one in-stock variant. If the top scorer is
  // unavailable, fall through to the next-best available device.
  function availableRanked() {
    return scores()
      .filter(([key, score]) => score > 0)
      .filter(([key]) => {
        const live = state.productData[key];
        return live && live.available !== false;
      });
  }

  function topAvailable() {
    const ranked = availableRanked();
    return ranked[0]?.[0] || null;
  }

  // Ultimate fallback: when no matched device is in stock, prefer the LED Max
  // mask, then the standard LED mask. Returns null only if neither is available
  // (in which case we show the out-of-stock notice).
  function resolvePrimary() {
    const top = topAvailable();
    if (top) return top;
    const ledMaxLive = state.productData.ledMax;
    if (ledMaxLive && ledMaxLive.available !== false) return 'ledMax';
    const faceMaskLive = state.productData.faceMask;
    if (faceMaskLive && faceMaskLive.available !== false) return 'faceMask';
    return null;
  }

  function productCard(key, isPrimary) {
    const p = PRODUCTS[key];
    const live = state.productData[key] || {};
    const image = live.image ? `<img class="zaine-device-quiz__image" src="${live.image}" alt="${p.name.replace(/"/g, '&quot;')}" loading="lazy">` : '';
    return `
      <div class="zaine-device-quiz__result-grid">
        <div class="zaine-device-quiz__image-wrap">${image || `<div class="zaine-device-quiz__match">Nuovaluce Device</div>`}</div>
        <div>
          <div class="zaine-device-quiz__match">${isPrimary ? 'Your best device match' : 'Also worth considering'}</div>
          <h2 class="zaine-device-quiz__product-title">${p.name}</h2>
          <p class="zaine-device-quiz__copy">${p.short}</p>
          <ul class="zaine-device-quiz__chips">${p.bestFor.map(x => `<li class="zaine-device-quiz__chip">${x}</li>`).join('')}</ul>
          <div class="zaine-device-quiz__cta-row">
            <a class="zaine-device-quiz__cta" href="${live.url || productUrl(p.handle)}">Shop this device</a>
            <button class="zaine-device-quiz__reset" type="button" data-zaine-reset>Retake quiz</button>
          </div>
        </div>
      </div>`;
  }


  function optionIcon(label) {
    const clean = label.toLowerCase();
    const icon = (name) => ({
      face: `<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M32 7c13 0 22 10 22 25S45 57 32 57 10 47 10 32 19 7 32 7Z"/><path d="M23 29h.1M41 29h.1M24 42c5 4 11 4 16 0"/><path d="M17 23c6-8 24-10 34 1"/></svg>`,
      eye: `<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M5 32s10-14 27-14 27 14 27 14-10 14-27 14S5 32 5 32Z"/><circle cx="32" cy="32" r="8"/><path d="M50 14l2-5 2 5 5 2-5 2-2 5-2-5-5-2 5-2Z"/></svg>`,
      jaw: `<svg class="zaine-device-quiz__svg-mark" viewBox="180 200 390 350" aria-hidden="true"><path d="M236 241 C220 258 228 277 235 303 C243 334 234 366 248 380 C265 397 326 380 380 357 C443 331 482 295 501 241" stroke-width="22"/><path d="M342 375 C357 402 359 431 349 462 C343 482 334 501 326 513" stroke-width="18"/><path d="M501 241 C490 270 482 300 481 334 C479 389 495 436 528 472" stroke-width="18"/></svg>`,
      body: `<svg viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="15" r="8"/><path d="M21 56c1-15 4-25 11-25s10 10 11 25"/><path d="M14 35c8-5 28-5 36 0"/></svg>`,
      heat: `<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M18 12c8 7 8 14 0 21M32 8c9 9 9 18 0 27M46 12c8 7 8 14 0 21"/><rect x="10" y="40" width="44" height="14" rx="7"/></svg>`,
      wrinkle: `<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M18 50c9-7 19-7 28 0"/><path d="M20 18c8-6 16-6 24 0"/><path d="M19 30h26M22 39h20"/><path d="M10 25l5-5 5 5M44 25l5-5 5 5"/></svg>`,
      lift: `<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M20 44c8 8 16 8 24 0"/><path d="M13 36l8-11 8 11M35 36l8-11 8 11"/><path d="M21 25v26M43 25v26"/></svg>`,
      glow: `<svg viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="32" r="10"/><path d="M32 6v10M32 48v10M6 32h10M48 32h10M13 13l7 7M44 44l7 7M51 13l-7 7M20 44l-7 7"/></svg>`,
      puffy: `<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M10 30c7-7 17-7 24 0M30 30c7-7 17-7 24 0"/><path d="M16 40c4 3 8 3 12 0M36 40c4 3 8 3 12 0"/><path d="M24 48h16"/></svg>`,
      recovery: `<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M15 44c8-14 26-14 34 0"/><path d="M18 31h28"/><path d="M24 20l-6 11 12-2M40 20l6 11-12-2"/><path d="M32 45v9"/></svg>`,
      hands: `<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M16 37c6-9 13-12 21-9"/><path d="M28 53l-13-9c-5-4-6-10-2-15"/><path d="M37 28l8 7c5 4 5 12 0 16l-3 2"/><path d="M38 11v11M48 16l-8 8M28 16l8 8"/></svg>`,
      target: `<svg viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="32" r="22"/><circle cx="32" cy="32" r="12"/><circle cx="32" cy="32" r="3"/><path d="M32 4v10M32 50v10M4 32h10M50 32h10"/></svg>`,
      daily: `<svg viewBox="0 0 64 64" aria-hidden="true"><rect x="12" y="14" width="40" height="38" rx="6"/><path d="M22 10v8M42 10v8M12 25h40M22 36l6 6 14-14"/></svg>`,
      workout: `<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M10 38h8M46 38h8M18 30v16M46 30v16M24 38h16"/><path d="M30 18l4-8 4 8"/><path d="M34 10v20"/></svg>`,
      beginner: `<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M32 8l6 12 13 2-9 9 2 13-12-6-12 6 2-13-9-9 13-2 6-12Z"/><path d="M26 33l4 4 9-10"/></svg>`,
      pro: `<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M14 45V19l18-10 18 10v26L32 55 14 45Z"/><path d="M23 32l6 6 13-15"/></svg>`,
      strength: `<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M18 42c3-16 25-16 28 0"/><path d="M23 27c2-9 16-9 18 0"/><path d="M12 50h40M32 12v10"/></svg>`,
      wellness: `<svg viewBox="0 0 64 64" aria-hidden="true"><path d="M32 54s-18-10-18-27c0-8 6-15 14-15 5 0 8 3 10 6 2-3 5-6 10-6 8 0 14 7 14 15 0 17-30 27-30 27Z"/><path d="M20 33h8l4-9 5 16 4-7h7"/></svg>`
    })[name];
    if (clean.includes('full face')) return icon('face');
    if (clean === 'eyes' || clean.includes('dark circles')) return icon('eye');
    if (clean.includes('neck') || clean.includes('jawline')) return icon('jaw');
    if (clean.includes('body, back') || clean.includes('body wellness')) return icon('body');
    if (clean.includes('sore') || clean.includes('heat') || clean.includes('tension')) return icon('heat');
    if (clean.includes('wrinkle')) return icon('wrinkle');
    if (clean.includes('firmness')) return icon('lift');
    if (clean.includes('glow') || clean.includes('radiance')) return icon('glow');
    if (clean.includes('puffiness')) return icon('puffy');
    if (clean.includes('recovery')) return icon('recovery');
    if (clean.includes('hands-free')) return icon('hands');
    if (clean.includes('targeted')) return icon('target');
    if (clean.includes('short daily')) return icon('daily');
    if (clean.includes('body recovery routine')) return icon('workout');
    if (clean.includes('first time')) return icon('beginner');
    if (clean.includes('beauty devices')) return icon('pro');
    if (clean.includes('strongest')) return icon('strength');
    if (clean.includes('shopping for body')) return icon('wellness');
    return `<svg viewBox="0 0 64 64" aria-hidden="true"><circle cx="32" cy="32" r="22"/><path d="M22 33l7 7 15-17"/></svg>`;
  }

  function selectedFor(q) {
    return state.multiDraft[q.id] || (Array.isArray(state.answers[q.id]) ? state.answers[q.id].map(a => a.label) : []);
  }

  function renderQuestion(root) {
    const q = QUESTIONS[state.step];
    const pct = Math.round((state.step / (QUESTIONS.length + 1)) * 100);
    const selected = q.multi ? selectedFor(q) : [];
    root.innerHTML = `
      <section class="zaine-device-quiz__hero" aria-label="Device quiz introduction">
        <h2 class="zaine-device-quiz__headline">Find your perfect at-home light therapy device.</h2>
        <p class="zaine-device-quiz__sub">Answer quick visual questions, drop your email, and get your personalized device match.</p>
      </section>
      <section class="zaine-device-quiz__card" aria-live="polite">
        <div class="zaine-device-quiz__progress" aria-hidden="true"><div class="zaine-device-quiz__bar" style="width:${pct}%"></div></div>
        <div class="zaine-device-quiz__eyebrow">${q.eyebrow}</div>
        <h3 class="zaine-device-quiz__title">${q.title}</h3>
        <p class="zaine-device-quiz__subtitle">${q.subtitle}</p>
        <ul class="zaine-device-quiz__options">
          ${q.options.map((opt, idx) => {
            const isSelected = selected.includes(opt.label);
            return `<li><button class="zaine-device-quiz__option ${isSelected ? 'is-selected' : ''}" type="button" data-zaine-option="${idx}" aria-pressed="${isSelected}"><span class="zaine-device-quiz__icon">${optionIcon(opt.label)}</span><span class="zaine-device-quiz__option-text">${opt.label}</span></button></li>`;
          }).join('')}
        </ul>
        <div class="zaine-device-quiz__nav">
          ${state.step > 0 ? '<button class="zaine-device-quiz__back" type="button" data-zaine-back>← Back</button>' : '<span></span>'}
          ${q.multi ? `<button class="zaine-device-quiz__next" type="button" data-zaine-next ${selected.length ? '' : 'disabled'}>Next</button>` : '<span></span>'}
        </div>
      </section>`;
  }


  function quizPayload(email, primary, answerSummary) {
    return {
      email,
      $email: email,
      source: 'Nuovaluce Device Quiz',
      quiz_name: 'Nuovaluce Device Finder',
      recommended_device: PRODUCTS[primary].name,
      recommended_device_key: primary,
      recommended_device_handle: PRODUCTS[primary].handle,
      quiz_answers: answerSummary,
      device_quiz_completed: true
    };
  }

  function klaviyoBeacon(endpoint, payload) {
    return new Promise(resolve => {
      try {
        const json = JSON.stringify(payload);
        const data = btoa(unescape(encodeURIComponent(json)));
        const img = new Image();
        const done = () => resolve(true);
        img.onload = done;
        img.onerror = done;
        img.src = `https://a.klaviyo.com/api/${endpoint}?data=${encodeURIComponent(data)}&cb=${Date.now()}`;
        setTimeout(done, 1800);
      } catch (err) {
        console.warn('[Nuovaluce device quiz] Klaviyo beacon failed', err);
        resolve(false);
      }
    });
  }

  async function subscribeKlaviyoQuizProfile(email, primary, answerSummary) {
    try {
      const subscriptionPayload = {
        data: {
          type: 'subscription',
          attributes: {
            custom_source: 'Nuovaluce Device Quiz',
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email,
                  properties: {
                    source: 'Nuovaluce Device Quiz',
                    quiz_name: 'Nuovaluce Device Finder',
                    recommended_device: PRODUCTS[primary].name,
                    recommended_device_key: primary,
                    recommended_device_handle: PRODUCTS[primary].handle,
                    device_quiz_completed: true,
                    quiz_answers: answerSummary
                  },
                  subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } }
                }
              }
            }
          },
          relationships: { list: { data: { type: 'list', id: 'WGCbaC' } } }
        }
      };
      const response = await fetch('https://a.klaviyo.com/client/subscriptions?company_id=WgVq6h', {
        method: 'POST',
        headers: {
          'content-type': 'application/vnd.api+json',
          'revision': '2026-07-15'
        },
        body: JSON.stringify(subscriptionPayload),
        keepalive: true
      });
      return response.ok || response.status === 202;
    } catch (err) {
      console.warn('[Nuovaluce device quiz] Klaviyo subscription failed', err);
      return false;
    }
  }

  async function sendKlaviyoQuizEvent(email, primary, answerSummary) {
    const payload = quizPayload(email, primary, answerSummary);
    const token = 'WgVq6h';
    try {
      window._klOnsite = window._klOnsite || [];
      const klaviyo = window.klaviyo;
      if (klaviyo && typeof klaviyo.identify === 'function') {
        Promise.resolve(klaviyo.identify(payload)).catch(() => {});
      } else if (window._learnq && typeof window._learnq.push === 'function') {
        window._learnq.push(['identify', payload]);
      } else {
        window._klOnsite.push(['identify', payload]);
      }

      if (klaviyo && typeof klaviyo.track === 'function') {
        Promise.resolve(klaviyo.track('Completed Device Quiz', payload)).catch(() => {});
      } else if (window._learnq && typeof window._learnq.push === 'function') {
        window._learnq.push(['track', 'Completed Device Quiz', payload]);
      } else {
        window._klOnsite.push(['track', 'Completed Device Quiz', payload]);
      }

      const identifyPayload = {
        token,
        properties: {
          $email: email,
          source: payload.source,
          quiz_name: payload.quiz_name,
          recommended_device: payload.recommended_device,
          recommended_device_key: payload.recommended_device_key,
          recommended_device_handle: payload.recommended_device_handle,
          device_quiz_completed: true
        }
      };
      const trackPayload = {
        token,
        event: 'Completed Device Quiz',
        customer_properties: { $email: email },
        properties: {
          source: payload.source,
          quiz_name: payload.quiz_name,
          recommended_device: payload.recommended_device,
          recommended_device_key: payload.recommended_device_key,
          recommended_device_handle: payload.recommended_device_handle,
          quiz_answers: payload.quiz_answers,
          device_quiz_completed: true
        },
        time: Math.floor(Date.now() / 1000)
      };
      await Promise.all([
        klaviyoBeacon('identify', identifyPayload),
        klaviyoBeacon('track', trackPayload)
      ]);
      localStorage.setItem('nuovaluce_device_quiz_klaviyo_status', 'beacon_sent');
      localStorage.setItem('nuovaluce_device_quiz_klaviyo_payload', JSON.stringify(payload));
      return true;
    } catch (err) {
      console.warn('[Nuovaluce device quiz] Klaviyo handoff failed', err);
      localStorage.setItem('nuovaluce_device_quiz_klaviyo_payload', JSON.stringify(payload));
      return false;
    }
  }

  async function submitQuizEmail(email) {
    const ranked = scores().filter(([, score]) => score > 0);
    const primary = resolvePrimary() || (ranked[0]?.[0] || 'ledMax');
    const answerSummary = Object.entries(state.answers).map(([key, value]) => {
      const labels = (Array.isArray(value) ? value : [value]).map(v => v.label).join(', ');
      return `${key}: ${labels}`;
    }).join(' | ');
    const body = new URLSearchParams();
    body.set('form_type', 'customer');
    body.set('utf8', '✓');
    body.set('contact[email]', email);
    body.set('contact[tags]', `newsletter,device-quiz,device-quiz-${primary}`);
    body.set('contact[note]', `Nuovaluce Device Quiz | Recommended: ${PRODUCTS[primary].name} | ${answerSummary}`);
    const subscriptionSent = await subscribeKlaviyoQuizProfile(email, primary, answerSummary);
    const klaviyoSent = await sendKlaviyoQuizEvent(email, primary, answerSummary);
    try {
      await fetch('/contact', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8' },
        body,
        credentials: 'same-origin'
      });
      localStorage.setItem('nuovaluce_device_quiz_email', email);
      localStorage.setItem('nuovaluce_device_quiz_klaviyo_sent', String(klaviyoSent));
      localStorage.setItem('nuovaluce_device_quiz_subscription_sent', String(subscriptionSent));
    } catch (err) {
      console.warn('[Nuovaluce device quiz] email capture failed', err);
    }
  }

  function renderEmail(root) {
    const pct = Math.round((QUESTIONS.length / (QUESTIONS.length + 1)) * 100);
    root.innerHTML = `
      <section class="zaine-device-quiz__hero" aria-label="Device quiz email capture">
        <h2 class="zaine-device-quiz__headline">Almost done — where should we send your match?</h2>
        <p class="zaine-device-quiz__sub">Get your personalized Nuovaluce device recommendation and a shortcut back to your result.</p>
      </section>
      <section class="zaine-device-quiz__card" aria-live="polite">
        <div class="zaine-device-quiz__progress" aria-hidden="true"><div class="zaine-device-quiz__bar" style="width:${pct}%"></div></div>
        <div class="zaine-device-quiz__email-card">
          <div class="zaine-device-quiz__eyebrow">Last step</div>
          <h3 class="zaine-device-quiz__title">Enter your email to reveal your device match.</h3>
          <p class="zaine-device-quiz__subtitle">We’ll save your result and add you to Nuovaluce updates. No weird skincare detour. No spam circus.</p>
          <form class="zaine-device-quiz__email-form" data-zaine-email-form>
            <input class="zaine-device-quiz__email-input" name="email" type="email" inputmode="email" autocomplete="email" placeholder="Email address" required value="${state.email || ''}">
            <button class="zaine-device-quiz__next" type="submit">See my device match</button>
            <p class="zaine-device-quiz__fine-print">By submitting, you agree to receive marketing emails from Nuovaluce. You can unsubscribe anytime.</p>
          </form>
        </div>
        <div class="zaine-device-quiz__nav">
          <button class="zaine-device-quiz__back" type="button" data-zaine-back>← Back</button>
          <span></span>
        </div>
      </section>`;
  }

  function renderLoading(root) {
    root.innerHTML = `
      <section class="zaine-device-quiz__hero">
        <h2 class="zaine-device-quiz__headline">Building your personalized glow match.</h2>
        <p class="zaine-device-quiz__sub">We’re weighing your treatment area, skin goals, routine style, and device experience.</p>
      </section>
      <section class="zaine-device-quiz__card" aria-live="polite" aria-busy="true">
        <div class="zaine-device-quiz__progress" aria-hidden="true"><div class="zaine-device-quiz__bar" style="width:96%"></div></div>
        <div class="zaine-device-quiz__loading">
          <div class="zaine-device-quiz__orb" aria-hidden="true"></div>
          <div class="zaine-device-quiz__eyebrow">Personalizing your result</div>
          <h3 class="zaine-device-quiz__title">Matching your answers to the right Nuovaluce routine.</h3>
          <p class="zaine-device-quiz__subtitle">This is not a generic best seller — it’s being tuned around what you told us.</p>
          <div class="zaine-device-quiz__loading-steps" aria-hidden="true">
            <span>Reading your primary treatment area</span>
            <span>Balancing glow, firmness, eye, and recovery goals</span>
            <span>Choosing the device path that fits your routine</span>
          </div>
        </div>
      </section>`;
  }

  function renderResult(root) {
    const ranked = scores().filter(([, score]) => score > 0);
    const primary = resolvePrimary() || null;
    if (!primary) {
      root.innerHTML = `
        <section class="zaine-device-quiz__hero">
          <h2 class="zaine-device-quiz__headline">Thanks — we've saved your match.</h2>
          <p class="zaine-device-quiz__sub">The devices that best match your answers are temporarily out of stock. Check back soon or browse the full collection.</p>
        </section>
        <section class="zaine-device-quiz__card">
          <div class="zaine-device-quiz__progress" aria-hidden="true"><div class="zaine-device-quiz__bar" style="width:100%"></div></div>
          <div class="zaine-device-quiz__cta-row">
            <a class="zaine-device-quiz__cta" href="/collections/holiday-sale-50-off-free-gift">Shop all Nuovaluce products</a>
            <button class="zaine-device-quiz__reset" type="button" data-zaine-reset>Retake quiz</button>
          </div>
        </section>`;
      return;
    }
    root.innerHTML = `
      <section class="zaine-device-quiz__hero">
        <h2 class="zaine-device-quiz__headline">Your routine should start here.</h2>
        <p class="zaine-device-quiz__sub">Based on your answers, this is the device path I’d put in front of a shopper first.</p>
      </section>
      <section class="zaine-device-quiz__card">
        <div class="zaine-device-quiz__progress" aria-hidden="true"><div class="zaine-device-quiz__bar" style="width:100%"></div></div>
        ${productCard(primary, true)}
      </section>`;
  }

  function bind(root) {
    root.addEventListener('submit', async event => {
      const form = event.target.closest('[data-zaine-email-form]');
      if (!form) return;
      event.preventDefault();
      const button = form.querySelector('button[type="submit"]');
      const email = (form.email?.value || '').trim();
      if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        form.email?.focus();
        return;
      }
      state.email = email;
      if (button) { button.disabled = true; button.textContent = 'Personalizing...'; }
      renderLoading(root);
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      const startedAt = Date.now();
      await submitQuizEmail(email);
      const remaining = Math.max(0, 2800 - (Date.now() - startedAt));
      if (remaining) await new Promise(resolve => setTimeout(resolve, remaining));
      state.step = QUESTIONS.length + 1;
      render(root);
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    root.addEventListener('click', event => {
      const option = event.target.closest('[data-zaine-option]');
      if (option) {
        const q = QUESTIONS[state.step];
        const picked = q.options[Number(option.dataset.zaineOption)];
        if (q.multi) {
          const current = new Set(state.multiDraft[q.id] || []);
          if (current.has(picked.label)) current.delete(picked.label);
          else current.add(picked.label);
          state.multiDraft[q.id] = [...current];
          render(root);
          return;
        }
        state.answers[q.id] = picked;
        if (state.step < QUESTIONS.length - 1) state.step += 1;
        else state.step = QUESTIONS.length;
        render(root);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (event.target.closest('[data-zaine-next]')) {
        const q = QUESTIONS[state.step];
        const labels = state.multiDraft[q.id] || [];
        if (!labels.length) return;
        state.answers[q.id] = q.options.filter(opt => labels.includes(opt.label));
        if (state.step < QUESTIONS.length - 1) state.step += 1;
        else state.step = QUESTIONS.length;
        render(root);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (event.target.closest('[data-zaine-back]')) {
        if (state.step === QUESTIONS.length) state.step = QUESTIONS.length - 1;
        else state.step = Math.max(0, state.step - 1);
        render(root);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (event.target.closest('[data-zaine-reset]')) {
        state.step = 0;
        state.answers = {};
        state.multiDraft = {};
        state.email = '';
        render(root);
        root.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  function render(root) {
    if (state.step === QUESTIONS.length) renderEmail(root);
    else if (state.step > QUESTIONS.length) renderResult(root);
    else renderQuestion(root);
  }

  async function mount() {
    if (document.getElementById('zaine-device-quiz')) return;
    injectStyles();
    document.body.classList.add('zaine-device-quiz-active');
    // The page content still contains an older static product-finder block.
    // Remove it so customers see one quiz and one set of answers only.
    document.querySelectorAll('.nl-quiz').forEach(node => node.remove());
    await fetchProducts();
    const rte = document.querySelector('main .rte') || document.querySelector('main');
    if (!rte) return;
    const root = document.createElement('div');
    root.id = 'zaine-device-quiz';
    root.className = 'zaine-device-quiz';
    root.dataset.version = VERSION;
    rte.prepend(root);
    bind(root);
    render(root);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mount);
  else mount();
  setTimeout(mount, 1200);
})();
